import Bots from '@webclient/components/pages/home/sections/bots';
import {
  StyledBox,
  StyledContainer,
  StyledContainerWrapper,
  StyledFlexbox,
  StyledFullHeightStack,
} from '@webclient/components/pages/home/styles';
import VoiceModeChat from '@webclient/components/pages/search/sections/results/real-time/components/voice-mode-chat';
import GamificationSearch from '@webclient/components/search-forms/gamification-search';

import LivekitRoomGateProvider from '@webclient/providers/LivekitRoomGateProvider';

import useAppSelector from '@webclient/hooks/useAppSelector';
import useResponsive from '@webclient/hooks/useResponsive';

import { roomInstance } from '@webclient/state/slices/search-session/utils/room-manager';

export default function Home() {
  const isItDesktop = useResponsive('up', 'md');
  const isVoiceChatLoading = useAppSelector(
    (state) => state.searchSession.voiceChatMode.state === 'loading',
  );

  if (isVoiceChatLoading) {
    return <VoiceModeChat loadingView />;
  }

  return (
    <LivekitRoomGateProvider
      room={roomInstance.get()}
      shouldRenderAudio
    >
      <StyledContainerWrapper
        disableGutters={isItDesktop}
        maxWidth={false}
      >
        <StyledFullHeightStack>
          <StyledFlexbox>
            <StyledContainer
              maxWidth="md"
              disableGutters
            >
              <Bots />
            </StyledContainer>
          </StyledFlexbox>

          <StyledBox>
            <GamificationSearch origin="home" />
          </StyledBox>
        </StyledFullHeightStack>
      </StyledContainerWrapper>
    </LivekitRoomGateProvider>
  );
}
